import { render, staticRenderFns } from "./AppCadastroContrato.vue?vue&type=template&id=17c48eae&"
import script from "./AppCadastroContrato.vue?vue&type=script&lang=js&"
export * from "./AppCadastroContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports